import BackpackService from "@tencent/midas-cgi/cgis/backpack"
import { getCgiObj } from "./cgi"

interface ToBackpackOptions {
  gameid: string
  game_platform_id: string
  item_id: string
  item_type: string
}

const defaultConfig = {
  hideLoading: false
}

class Backpack {
  private cgiObj
  private cgiNames

  /**
   * 构造函数
   * @param options 初始化cgiObj所需参数
   */
  constructor(options) {
    const { pf, sandbox, sessionObj, offerId } = options

    this.cgiObj = getCgiObj({
      pf,
      sandbox,
      sessionObj,
      offerId
    })

    this.cgiNames = {
      BackpackService: new BackpackService(defaultConfig)
    }
  }

  /**
   * 查询背包列表
   * @param area
   * @param game_platform_id
   * @param partition
   * @param roleid
   */
  queryBackpackList({ area, game_platform_id, partition, roleid }): Promise<any> {
    const params = {
      action: "query_bag",
      area,
      game_platform_id,
      partition,
      roleid
    }

    return this.cgiObj.request(this.cgiNames["BackpackService"], params)
  }

  /**
   * 查询背包列表
   * @param area
   * @param game_platform_id
   * @param partition
   * @param roleid
   * @param subject_id
   */
  queryBackpackListBySubjectIds({ area, game_platform_id, partition, roleid, subject_id }): Promise<any> {
    const params = {
      action: "batch_query_subject",
      area,
      game_platform_id,
      partition,
      roleid,
      subject_id
    }

    return this.cgiObj.request(this.cgiNames["BackpackService"], params)
  }

  /**
   * 查询背包详情（单个）
   * @param area
   * @param game_platform_id
   * @param partition
   * @param roleid
   * @param subject_id
   */
  queryBackpackDetail({ area, game_platform_id, partition, roleid, subject_id }): Promise<any> {
    const params = {
      action: "query_subject",
      area,
      game_platform_id,
      partition,
      roleid,
      subject_id
    }

    return this.cgiObj.request(this.cgiNames["BackpackService"], params)
  }

  /**
   * 将礼包中心的物品领取到背包
   * @param gameid
   * @param game_platform_id
   * @param item_id
   * @param item_type
   * @returns
   */
  giftCenterToBackpack({ gameid, game_platform_id, item_id, item_type }: ToBackpackOptions): Promise<any> {
    const params = {
      action: "gift_center_to_backpack",
      gameid,
      game_platform_id,
      item_id,
      item_type
    }

    return this.cgiObj.request(this.cgiNames["BackpackService"], params)
  }
}

export default Backpack
